import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  column: FelaCSS;
  title: FelaCSS;
  description: FelaCSS;
  findPhotographer: FelaCSS;
  photographerCard: FelaCSS;
  buttonWrapper: FelaCSS;
}

interface IParams {
  isMobile: boolean;
}

const styles = ({ isMobile }: IParams): IStyles => ({
  wrapper: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    ...(isMobile
      ? {
          rowGap: '24px',
        }
      : {
          marginTop: '16px',
        }),
  },
  column: {
    flexShrink: 0,
    ...(isMobile
      ? {}
      : {
          width: '50%',
        }),
  },
  findPhotographer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    ...(isMobile
      ? {
          justifyContent: 'space-between',
          rowGap: '12px',
        }
      : {
          justifyContent: 'center',
          rowGap: '20px',
          paddingLeft: '3em',
        }),
  },
  title: {
    fontDefaultSemiBold: 22,
    lineHeight: '31px',
    color: colors.space75,
  },
  description: {
    fontDefault: isMobile ? 14 : 16,
    color: colors.space60,
  },
  photographerCard: {
    ...(isMobile
      ? {}
      : {
          paddingLeft: '4em',
          paddingRight: '4em',
        }),
  },
  buttonWrapper: {
    width: '219px',
  },
});

export default styles;
